import styled from '@emotion/styled';

interface ContainerProps {
  noGap?: boolean;
  bgColor?: string;
}

//DESIGNED FOR ACTION & RESULT PAGES
export const PageContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 24px auto;
  background-color:${({ bgColor }: ContainerProps) => (bgColor ? bgColor : '#ebebeb')}; 
  display: flex;
  gap: ${({ noGap }: ContainerProps) => (noGap ? '0px' : '16px')};
  flex-direction: column;
`;
